// extracted by mini-css-extract-plugin
module.exports = {"creationMedia":"LatestNFTs_creationMedia__ZO5Ko","creationMediaContainer":"LatestNFTs_creationMediaContainer__54MIA","noNFTs":"LatestNFTs_noNFTs__esLSj"};